(() => {
  function initTestimonialSliderSwipers(root = document) {
    root.querySelectorAll('[data-testimonial-slider-swiper]').forEach((swiperElement) => {
      if (swiperElement.dataset.swiperInitialized === 'true' || !window.Swiper) return;

      const section = swiperElement.closest('.custom-testimonial-slider');
      const progress = section.querySelector('[data-testimonial-slider-progress]');
      const count = section.querySelector('[data-testimonial-slider-count]');
      const total = swiperElement.querySelectorAll('.swiper-slide').length;

      if (!total) return;

      const updateIndicator = (swiper) => {
        const current = swiper.activeIndex + 1;
        if (progress) progress.style.width = `${(current / total) * 100}%`;
        if (count) count.textContent = `${current}/${total}`;
      };

      swiperElement.dataset.swiperInitialized = 'true';

      new window.Swiper(swiperElement, {
        slidesPerView: 1,
        speed: 500,
        autoHeight: true,
        watchOverflow: true,
        grabCursor: total > 1,
        a11y: {
          enabled: true
        },
        on: {
          init: updateIndicator,
          slideChange: updateIndicator
        }
      });
    });
  }

  function bootTestimonialSliderSwipers(root = document) {
    loadSwiperCss();
    loadSwiperScript().then(() => initTestimonialSliderSwipers(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootTestimonialSliderSwipers());
  } else {
    bootTestimonialSliderSwipers();
  }

  document.addEventListener('shopify:section:load', (event) => bootTestimonialSliderSwipers(event.target));
})();
